import { Grid, Typography, Box } from "@mui/material";

import eqImage from "../../../static/images/TSDD/intelleq.webp"

const textColor = "#000"

const EQBanner = () => {
  return <>
    <Box sx={{ p: 5, background: "radial-gradient(circle, #ff7717ff 0%,#e07e29 100%)", justifyContent: "center", alignItems: "center", color: textColor }} >
      <Grid container justifyContent={"center"} sx={{}}>
        <Grid item xs={12} md={10} sx={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
          <img src={eqImage} width="50%" style={{ maxWidth: "1400px" }} alt="Cabinets" />
        </Grid>

      </Grid>
      <Grid container justifyContent={"center"} sx={{}}>
        <Grid item xs={12} md={6} lg={6} sx={{}}>
          <Typography sx={{ textAlign: "center", mb: 3, }} variant="h3">IntellEQ</Typography>
          <Typography sx={{ textAlign: "center", mb: 3 }} variant="h6">IntellEQ is a smart guitar EQ that speaks your language.
            Instead of endless frequency charts and tiny boost/cut sliders, you get musical controls that match how guitar players actually talk about tone. <br /> <br /> Want more bite in your tone? Simply turn up the bite control. Want more scooped sounding guitars? Play around with the scoop controls.

            <br /><br /> You can turn up every knob to 10 and it will still sound good.</Typography>
          <Typography sx={{ textAlign: "center", mb: 3 }} variant="h6"></Typography>
        </Grid>
      </Grid>

    </Box >
  </ >
}

export default EQBanner;
